.header {
  max-width: 44rem;
  margin-bottom: var(--sp-10);
}
/* One-off for the homepage trust band: a wide column and a quiet heading, since the
   logos under it carry the section, without changing SectionHeader everywhere else. */
.header:has(:global(#trust-title)) {
  max-width: 60rem;
  margin-bottom: var(--sp-8);
}
:global(#trust-title) {
  font-size: clamp(var(--fs-lg), 0.6vw + 0.95rem, var(--fs-xl));
  font-weight: 500;
  letter-spacing: -0.01em;
  color: var(--text);
}
.center {
  margin-inline: auto;
  text-align: center;
}
.text {
  margin-top: var(--sp-4);
  font-size: var(--fs-md);
}

/* ---- split header ------------------------------------------------------- */
.split {
  display: grid;
  gap: var(--sp-5) var(--sp-16);
  max-width: none;
  margin-bottom: var(--sp-12);
}
/* On the heading, not .main: `ch` follows the element's own font size, so this is ~22
   characters of the headline itself. Long headlines break into balanced lines. */
.main :is(h2, h3) {
  max-width: 22ch;
  text-wrap: balance;
}
.aside {
  display: grid;
  justify-items: start;
  gap: var(--sp-4);
  max-width: 30rem;
}
.asideText {
  margin: 0;
  font-size: var(--fs-md);
  color: var(--text);
}
.link {
  font-weight: 600;
  color: var(--text-strong);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.3em;
  transition:
    color var(--dur) var(--ease),
    text-decoration-color var(--dur) var(--ease);
}
.link:hover {
  color: var(--accent-text);
  text-decoration-color: currentColor;
}
/* The link with controls at the other end of its line, across the full width the
   content under the header takes. */
.linkRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  justify-self: stretch;
}
@media (max-width: 63.99rem) {
  .aside:has(> .linkRow) {
    max-width: none;
  }
  .aside:has(> .linkRow) .asideText {
    max-width: 30rem;
  }
}
@media (min-width: 64rem) {
  .split {
    grid-template-columns: minmax(0, 7fr) minmax(0, 4fr);
    /* The aside lines up with the headline's last line, so it reads as the headline's
       caption and its link sits just above the content it leads into. */
    align-items: end;
  }
}
